"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../index");

var _lodash = _interopRequireDefault(require("lodash"));

var _UserModel = _interopRequireDefault(require("../../../users/all-users/models/UserModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SelectSpecificUsers = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectSpecificUsers, _React$Component);
  /**
   * Constructor
   *
   * @param {object} props Props
   */


  function SelectSpecificUsers(props) {
    var _this;

    _classCallCheck(this, SelectSpecificUsers);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectSpecificUsers).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_debounceFilter", _lodash["default"].debounce(function () {
      return _this._triggerFilter();
    }, 200));

    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    console.log("props", props);
    _this.state = {
      term: "",
      results: [],
      selectedIds: props.userIds ? props.userIds : [],
      selectedUsers: []
    };
    return _this;
  }
  /**
   * Call on component mount
   */


  _createClass(SelectSpecificUsers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);

      this._pullSelectedUsers();
    }
    /**
     * Call on component unmount
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
    /**
     * Handle click outside the wrapper
     *
     * @param {object} event
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({
          term: "",
          results: []
        });
      }
    }
    /**
     * Show filtered users
     */

  }, {
    key: "_showFilteredUsers",
    value: function _showFilteredUsers() {
      var _this2 = this;

      var results = this.state.results;

      if (!results || !results.length) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "filtered-users-holder",
        ref: function ref(_ref) {
          return _this2.wrapperRef = _ref;
        }
      }, _react["default"].createElement("ul", {
        className: "filtered-results"
      }, results.map(function (user, index) {
        return _react["default"].createElement(UserFilterItem, {
          user: user,
          index: index,
          selectedIds: _this2.state.selectedIds,
          onAdd: function onAdd(id) {
            return _this2._addUser(id);
          },
          onRemove: function onRemove(id) {
            return _this2._removeUser(id);
          }
        });
      })));
    }
    /**
     * Show selected users
     */

  }, {
    key: "_showSelectedUsers",
    value: function _showSelectedUsers() {
      var _this3 = this;

      var selectedUsers = this.state.selectedUsers;

      if (!selectedUsers || !selectedUsers.length) {
        return _react["default"].createElement("em", null, "no users selected");
      }

      return _react["default"].createElement("div", {
        className: "selected-users-holder"
      }, _react["default"].createElement("ul", {
        className: "filtered-results"
      }, selectedUsers.map(function (user, index) {
        if (_this3.state.selectedIds.filter(function (x) {
          return x == user.id;
        }).length == 0) return null;
        return _react["default"].createElement(UserFilterItem, {
          user: user,
          index: index,
          selectedIds: _this3.state.selectedIds,
          onAdd: function onAdd(id) {
            return _this3._addUser(id);
          },
          onRemove: function onRemove(id) {
            return _this3._removeUser(id);
          }
        });
      })));
    }
    /**
     * Add user id
     *
     * @param {integer} userId User id
     */

  }, {
    key: "_addUser",
    value: function _addUser(userId) {
      var _this4 = this;

      if (!this.state.selectedIds.filter(function (x) {
        return x == userId;
      }).length) {
        this.setState({
          selectedIds: [].concat(_toConsumableArray(this.state.selectedIds), [userId])
        }, function () {
          _this4.props.onChange(_this4.state.selectedIds);

          _this4._pullSelectedUsers();
        });
      }
    }
    /**
     * Remove user id
     *
     * @param {integer} userId User id
     */

  }, {
    key: "_removeUser",
    value: function _removeUser(userId) {
      var _this5 = this;

      this.setState({
        selectedIds: this.state.selectedIds.filter(function (x) {
          return x != userId;
        })
      }, function () {
        _this5.props.onChange(_this5.state.selectedIds);

        _this5._pullSelectedUsers();
      });
    }
    /**
     * Pull selected users
     */

  }, {
    key: "_pullSelectedUsers",
    value: function () {
      var _pullSelectedUsers2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _UserModel["default"]().fetch({
                  limit: 10000,
                  filter: [{
                    name: "ids",
                    field: "id",
                    value: this.state.selectedIds
                  }]
                });

              case 2:
                results = _context.sent;
                this.setState({
                  selectedUsers: results.items
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _pullSelectedUsers() {
        return _pullSelectedUsers2.apply(this, arguments);
      }

      return _pullSelectedUsers;
    }()
    /**
     * Changed search value - trigger filter
     *
     * @param {string} value Term
     */

  }, {
    key: "_changedSearch",
    value: function _changedSearch(value) {
      var _this6 = this;

      this.setState({
        term: value
      }, function () {
        _this6._debounceFilter();
      });
    }
    /**
     * Trigger filter
     */

  }, {
    key: "_triggerFilter",
    value: function () {
      var _triggerFilter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var term, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                term = this.state.term; // Term limit is 3

                if (!(!term || term.length < 3)) {
                  _context2.next = 4;
                  break;
                }

                this.setState({
                  results: []
                });
                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return new _UserModel["default"]().fetch({
                  term: this.state.term,
                  limit: 5
                });

              case 6:
                result = _context2.sent;
                this.setState({
                  results: result.items
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _triggerFilter() {
        return _triggerFilter2.apply(this, arguments);
      }

      return _triggerFilter;
    }()
    /**
     * Debounce filter function
     */

  }, {
    key: "render",

    /**
     * Render
     */
    value: function render() {
      var _this7 = this;

      return _react["default"].createElement("div", {
        className: "search-users dark-well"
      }, _react["default"].createElement("em", null, "Search for users"), _react["default"].createElement("div", {
        className: "filter-section"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        autoComplete: "off",
        onChange: function onChange(e) {
          return _this7._changedSearch(e.target.value);
        },
        label: "",
        type: "text",
        name: "name",
        value: this.state.term
      }), this._showFilteredUsers()), this._showSelectedUsers());
    }
  }]);

  return SelectSpecificUsers;
}(_react["default"].Component);

exports["default"] = SelectSpecificUsers;
SelectSpecificUsers.defaultProps = {
  onChange: function onChange() {}
};

var UserFilterItem = /*#__PURE__*/function (_React$Component2) {
  _inherits(UserFilterItem, _React$Component2);

  function UserFilterItem() {
    _classCallCheck(this, UserFilterItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserFilterItem).apply(this, arguments));
  }

  _createClass(UserFilterItem, [{
    key: "render",

    /**
     * Render user filter item
     */
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          user = _this$props.user,
          selectedIds = _this$props.selectedIds,
          onAdd = _this$props.onAdd,
          onRemove = _this$props.onRemove;
      return _react["default"].createElement("li", {
        key: index
      }, _react["default"].createElement("div", {
        className: "user-info"
      }, _react["default"].createElement("h5", null, user.fullName), _react["default"].createElement("span", null, "E-mail: ", user.email), _react["default"].createElement("br", null), _react["default"].createElement("span", null, "ID: ", user.id)), _react["default"].createElement("div", {
        className: "user-actions"
      }, selectedIds.filter(function (x) {
        return x == user.id;
      }).length == 0 ? _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: "button button-danger",
        onClick: function onClick() {
          return onAdd(user.id);
        }
      }, "Add") : _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: "button button-danger",
        onClick: function onClick() {
          return onRemove(user.id);
        }
      }, "Remove")));
    }
  }]);

  return UserFilterItem;
}(_react["default"].Component);